import { render } from "./privacityView.vue?vue&type=template&id=41e450da&scoped=true"
import script from "./privacityView.vue?vue&type=script&lang=js"
export * from "./privacityView.vue?vue&type=script&lang=js"

import "./privacityView.vue?vue&type=style&index=0&id=41e450da&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e450da"]])

export default __exports__